import { getLocaleForDateFns as themeGetLocaleForDateFns } from '@avangard/ui/translations';

import { i18n } from '@lib/i18n';

export const getLocaleForDateFns = () => themeGetLocaleForDateFns(i18n.language);
